import { render } from "./CreateLimitLocationAvailabilityForm.vue?vue&type=template&id=400504f6"
import script from "./CreateLimitLocationAvailabilityForm.vue?vue&type=script&lang=js"
export * from "./CreateLimitLocationAvailabilityForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__